module.exports = __webpack_public_path__ + "static/media/time-back.6d343163.svg";